import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';
import capitalize from '@afosto/utils/string/capitalize';
import ClientFormatter from '@afosto/utils-react/formatters/ClientFormatter';
import ContactFormatter from '@afosto/utils-react/formatters/ContactFormatter';
import OrganisationFormatter from '@afosto/utils-react/formatters/OrganisationFormatter';
import OrderTypeFormatter from './formatters/OrderTypeFormatter';
import OrderTagsFormatter from './formatters/OrderTagsFormatter';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const ORDERS_APP_ORIGIN = BASE_URL.replace('{app}', 'orders');

export const orderFormatter = (cell, row) => {
  const isSameOrigin = window.location.origin === ORDERS_APP_ORIGIN;

  if (isSameOrigin) {
    return (
      <MuiLink variant="subtitle1" component={Link} to={`/orders/${row.id}`}>
        {row?.number?.toUpperCase() || '-'}
      </MuiLink>
    );
  }

  return (
    <MuiLink variant="subtitle1" href={`${ORDERS_APP_ORIGIN}/orders/${row.id}`}>
      {row?.number?.toUpperCase() || '-'}
    </MuiLink>
  );
};

export const contactFormatter = cell => <ContactFormatter contactId={cell} />;

export const organisationFormatter = cell => <OrganisationFormatter organisationId={cell} />;

export const clientFormatter = cell => <ClientFormatter clientId={cell} />;

export const orderTypeFormatter = cell => <OrderTypeFormatter type={cell} />;

export const orderTagsFormatter = cell => <OrderTagsFormatter orderTags={cell} />;

export const orderProgressStatusFormatter = cell => {
  if (!cell) {
    return '-';
  }

  return (
    <FormattedMessage
      id={`orderProgressStatus.${cell}`}
      defaultMessage={capitalize(cell)}
      description={`Translation of order progress status ${cell}`}
    />
  );
};

export default orderFormatter;
